import { ChildSection } from '@/types/Child'
import { JSX } from 'react'

export function getPrimarySection(sections: ChildSection[]): JSX.Element {
    const section: ChildSection | undefined = sections.find((section: ChildSection): boolean => section.isPrimary)

    if (section) {
        return <span>{section.sectionName}</span>
    } else {
        return <></>
    }
}
